module.exports = __webpack_public_path__ + "static/img/user2-160x160.2e30e5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/sys/home/user2-160x160.jpg
// module id = lKd1
// module chunks = 7